document.addEventListener("DOMContentLoaded", function () {
  const searchInput = document.getElementById("predictive-search-input");
  const resultsContainer = document.getElementById("predictive-search-results");

  if (!searchInput || !resultsContainer) return;

  let debounceTimer;

  // Enter/submit-knop: blijf op de huidige pagina en toon resultaten inline
  // (zelfde gedrag als vivapets.nl). De <form action="..."> blijft als fallback
  // staan voor het geval JavaScript niet laadt.
  const searchForm = searchInput.closest('form');
  if (searchForm) {
    searchForm.addEventListener('submit', function (e) {
      e.preventDefault();
      clearTimeout(debounceTimer);
      const query = searchInput.value.trim();
      if (query.length >= 2) fetchPredictiveResults(query);
    });
  }

  searchInput.addEventListener("input", function () {
    const query = searchInput.value.trim();

    // Clear previous timeouts to prevent spamming queries
    clearTimeout(debounceTimer);

    if (query.length < 2) {
      resultsContainer.hidden = true;
      resultsContainer.innerHTML = "";
      return;
    }

    // Debounce API call for 300ms
    debounceTimer = setTimeout(() => {
      fetchPredictiveResults(query);
    }, 300);
  });

  function fetchPredictiveResults(query) {
    // Request returns data parsed specifically for products
    
    const searchBase = (window.themeSettings && window.themeSettings.searchUrl) || '/search';
    const searchUrl = `${searchBase}/suggest?q=${encodeURIComponent(query)}&resources[type]=product&section_id=search-results`;

    fetch(searchUrl)
        .then(response => response.text())
        .then(html => {

            const doc = new DOMParser()
            .parseFromString(html, 'text/html');

            const section = doc.querySelector('#shopify-section-search-results');

            resultsContainer.innerHTML = section.innerHTML;
            resultsContainer.hidden = false;

             // Read the value
            const searchMeta = doc.querySelector('#predictive-search-meta');
            const cbgLogoAny = searchMeta?.dataset.cbgLogoAny === 'true';
            var cbgEl = document.getElementById('cbg-logo-box-any');
            if (cbgEl) {
              cbgEl.style.display = ( cbgLogoAny ? 'block' : 'none' );
            }
            
            // Before creating a new swiper, optionally destroy the old one:
            if (window.searchSwiper) {
              window.searchSwiper.destroy(true, true);
            }

            window.searchSwiper = new Swiper(".swiper-product-search", {
              cssMode: false,
                  // See assets/base-swiper.js for why this is off - prevents a long/fast
                  // swipe from jumping multiple slides instead of moving one at a time.
                  followFinger: false,
                  breakpoints: {
                    "@0.0": 
                      { 
                        slidesPerGroup: 1,
                      },
                    "@0.75": 
                      { 
                        slidesPerGroup: 2,
                      },
                    "@1.00": 
                      { 
                        slidesPerGroup: 3,
                      },
                    "@1.50": 
                      { 
                        slidesPerGroup: 3,
                      },
                },
                slidesPerView: "auto",
                  spaceBetween: 10,
                  speed: 100,
                activeIndex: 1,
                    mousewheel: {
                    forceToAxis: true,
                  },
                  // If we need pagination
                  pagination: {
                      el: ".swiper-pagination-product-search",
                      clickable: true,
                      dynamicBullets: true,
                      dynamicMainBullets: 5
                  },
                  hashNavigation: {
                    watchState: true,
                  },});

            if (typeof window.equalizeProductCardNames === 'function') {
              window.equalizeProductCardNames();
            }
        });
  }

  // Close the dropdown when clicking outside of it
  document.addEventListener("click", function (e) {
    if (!searchInput.contains(e.target) && !resultsContainer.contains(e.target)) {
      resultsContainer.hidden = true;
    }
  });
});